import { render } from "./setCpf.vue?vue&type=template&id=2b42072c&scoped=true"
import script from "./setCpf.vue?vue&type=script&lang=js"
export * from "./setCpf.vue?vue&type=script&lang=js"

import "./setCpf.vue?vue&type=style&index=0&id=2b42072c&scoped=true&lang=css"
import "./setCpf.vue?vue&type=style&index=1&id=2b42072c&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b42072c"]])

export default __exports__